
<template>
	<compWrapper title="基本信息" theme="primary">
		<compFormQuery
			v-if="type==='query'"
			class="margin-right-15 margin-top-15"
			:formdata="getBase"
			:value="formData"
		></compFormQuery>
		<compFormEdit
			v-else
			ref="form"
			class="margin-right-15 margin-top-15"
			:formdata="getBase"
			v-model="formData"
		></compFormEdit>
		<footer class="text-right" v-if="!review">
			<Button type="primary" class="width-15per margin-right-15 margin-top-15" @click="nextStep">下一步</Button>
		</footer>
	</compWrapper>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { HttpShipBill } from '@/service/boss/shipment'
export default {
	props: ['data', 'type', 'status', 'parentId'],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormEdit: () => import("@components/templates/formedit"),
		compFormQuery: () => import("@components/templates/formquery"),
	},
	data() {
		return {
			formData: {
				carrierCompany: "",
				shipType: 0,
				orgwarehouseId: '',
				currency: 'USD',
				relationBillNos: '',
				lotNos: '',
				carrierType: '',
				expectCabinetsAt: '',
				expectArrivalAt: '',
				remark: '',
				cancelExplain: '',
			}
		}
	},
	created() {
		this.formData = { ...this.formData, ...this.data };
	},
	computed: {
		...mapState('boss', ['products']),
		...mapGetters('boss', ['warehouses']),
		...mapGetters('diction',['getAllCurrency']),
		getBase() {
			const query = this.review,
				show = this.type === 'query',
				{ orderStatus, shipType, orgwarehouseId, shipmentCode, carrierType } = this.formData,
				warehouses = this.warehouses.map(function (item) {
					return {
						value: item.id,
						label: `${item.code}(${item.title})`
					}
				}),
				shipmentCodeList = {
					shippingFCL: "海运整柜",
					shippingLCL: "海运散箱",
					ownLCL: "自散箱",
					airlift: "空运",
					FMS: "快递",
					shipping: "海运"
				};
			warehouses.unshift({
				value: 9999,
				label: "OTHER"
			});
			const warehousevalue = warehouses.find(function (item) {
				return orgwarehouseId == item.value
			}) || { label: 'OTHER' };
			return [{
				label: '发运计划单号',
				key: 'shipmentNo',
				show: query,
				query,
			}, {
				label: '发运类型',
				tag: 'vRadio',
				key: 'shipType',
				query,
				valueText: ['直发', '中转'][shipType],
				props: {
					strict: false,
				},
				options: [{
					trueValue: '0',
					label: '直发'
				}, {
					trueValue: '1',
					label: '中转'
				}]
			}, {
				label: '中转仓',
				tag: 'vSelect',
				key: 'orgwarehouseId',
				show: shipType == 1,
				query,
				valueText: warehousevalue.label,
				options: warehouses,
				required: false,
			}, {
				label: '运费币种',
				tag: 'vSelect',
				key: 'currency',
				query,
				options: this.getAllCurrency
			}, {
				label: '物流单号',
				key: 'logisticNos',
				query,
				show,
			}, {
				label: '预估运费',
				key: 'estimateCost',
				query,
				show,
			}, {
				label: '实际运费',
				key: 'actualCost',
				query,
				show,
			}, {
				label: '发运日期',
				key: 'actualSailAt',
				query,
				show,
			}, {
				label: '运输方式',
				key: 'logisticNos',
				valueText: shipmentCodeList[shipmentCode],
				query,
				show,
			}, {
				label: '关联单号',
				key: 'relationBillNos',
				query,
				required: false,
				formItem: {
					tip: query ? null : '<div class="color-error">Tips：如补录溢装单，可填写原发运单号便于追溯。</div>'
				}
			}, {
				label: '内部识别号',
				key: 'lotNos',
				required: false,
				query,
				formItem: {
					tip: query ? null : '<div class="color-error">Tips：如工厂批号等识别号</div>'
				}
			}, {
				label: '运费分摊方式',
				valueText: '体积分摊',
				query,
				show,
			}, {
				label: '货代类型',
				key: 'carrierType',
				tag: 'vSelect',
				options: ['BIZARK', 'OTHER'],
				query,
			}, {
				label: '货代名称',
				key: 'carrierCompany',
				query,
				show: carrierType === 'OTHER',
			}, {
				label: '期望装柜日期',
				key: 'expectCabinetsAt',
				tag: 'vDatepicker',
				props: {
					format: "yyyy-mm-dd",
					confirm: false,
				},
				query,
			}, {
				label: '期望到货日期',
				key: 'expectArrivalAt',
				tag: 'vDatepicker',
				props: {
					format: "yyyy-mm-dd",
					confirm: false,
				},
				query,
			}, {
				label: '备注',
				key: 'remark',
				tag: 'vTextarea',
				query,
				required: false,
			}, {
				label: '取消原因',
				key: 'cancelExplain',
				query: true,
				show: query && orderStatus == 'close'
			}]
		},
		review() {
			return this.status === 'review'
		}
	},
	methods: {
		async nextStep() {
			const valid = await this.$refs['form'].validate();
			if (!valid) return;
			const parent = this.$parent;
			parent.baseData = {
				...this.formData,
			};
			parent.submitHeadBill();
		}
	},

}
</script>

